import {
  Select,
  Option,
  RadioButtonGroup,
  RadioButton,
  Form,
  Button,
  ModalManagerContext,
} from '@pega/cosmos-react-core';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { multiChannelRes } from '../../../../interfaces/common';

interface AddChannelProps {
  availableChannels: multiChannelRes;
  addChannelCallback: (channelname: string, connectionId: string) => void;
}

type AddChannelFormData = {
  channel: string;
  connection: string;
};

const AddChannel: React.FC<AddChannelProps> = (props) => {
  const { availableChannels, addChannelCallback } = props;
  const [selectedChannel, setSelectedChannel] = useState('');
  const translate = useLocalTranslation();
  const { register, handleSubmit, errors, formState } = useForm<AddChannelFormData>({
    mode: 'all',
    defaultValues: {
      connection: '',
      channel: '',
    },
  });
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);
  const addChannel = ({ channel, connection }: AddChannelFormData) => {
    if (formState.isValid) {
      addChannelCallback(channel, connection);
      dismiss();
    }
  };

  const submitCallback = () => {
    handleSubmit(addChannel)();
  };

  const actions = (
    <>
      <Button onClick={dismiss}>{translate('cancel')}</Button>
      <Button variant="primary" onClick={submitCallback} disabled={!formState.isValid}>
        {translate('submit')}
      </Button>
    </>
  );
  return (
    <Form actions={actions}>
      <Select
        label={translate('channel')}
        required={true}
        name="channel"
        info={errors.channel?.message}
        status={errors.channel?.message ? 'error' : undefined}
        ref={register({ required: translate('select_channel_error') })}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          setSelectedChannel(e.target.value);
        }}
      >
        <Option value="">{translate('choose_an_option')}</Option>
        {Object.keys(availableChannels)
          .sort()
          .filter((item: string) => availableChannels[item]?.length)
          .map((item, index) => {
            return (
              <Option value={item} key={index}>
                {translate(item)}
              </Option>
            );
          })}
      </Select>
      <RadioButtonGroup
        label={translate('connections_heading')}
        required={true}
        name="connection"
        info={errors.connection?.message}
        status={errors.connection?.message ? 'error' : undefined}
      >
        {availableChannels[selectedChannel]?.map((item, index) => {
          return (
            <RadioButton
              key={index}
              label={item.title}
              ref={register({ required: translate('select_connection_error') })}
              value={item.connectionId}
            />
          );
        })}
      </RadioButtonGroup>
    </Form>
  );
};

export default AddChannel;
